import React from "react";
import moment from "moment";
import "moment/locale/tr";

moment.locale("tr");

const KitiRecharge = ({ data }) => {
  
  const KitiRechargeCard = ({ item }) => (
    <div className="bg-gradient-to-r from-gray-800/40 to-gray-800/20 rounded-xl p-4 mb-4 shadow-lg hover:shadow-xl hover:from-gray-700/40 hover:to-gray-700/20 transition-all duration-300 border border-gray-700/50">
      <div className="space-y-3">
        {/* User - Full Width */}
        <div className="border-b border-gray-600/30 pb-3">
          <div className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Kullanıcı</div>
          <div className="font-semibold text-white-100 text-lg break-words">{item.user}</div>
        </div>
        
        {/* Amount and Date - Side by Side */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Tutar</div>
            <div className="font-bold text-green-400 text-lg">
              {item.amount.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
            </div>
          </div>
          <div>
            <div className="text-xs text-gray-400 uppercase tracking-wide font-medium mb-1">Tarih</div>
            <div className="font-medium text-gray-200 text-sm">{moment(item.date).format("LLL")}</div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="w-full p-2 md:p-4">
      {/* Mobile Cards */}
      <div className="md:hidden">
        {data?.map((item, index) => (
          <KitiRechargeCard key={`${item.user}-${item.date}-${index}`} item={item} />
        ))}
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-700 text-sm">
          <thead className="">
            <tr>
              <th className="px-3 py-3 text-left font-medium text-white-100 text-xs md:text-sm">Kullanıcı</th>
              <th className="px-3 py-3 text-left font-medium text-white-100 text-xs md:text-sm">Tutar</th>
              <th className="px-3 py-3 text-left font-medium text-white-100 text-xs md:text-sm">Tarih</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700/30">
            {data?.map((item, index) => (
              <tr key={`${item.user}-${item.date}-${index}`} className="hover:bg-gray-700/20">
                <td className="px-3 py-2 text-white-100 text-xs md:text-sm max-w-[200px] truncate">{item.user}</td>
                <td className="px-3 py-2 font-medium text-white-100 text-xs md:text-sm">{item.amount.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                <td className="px-3 py-2 text-white-100 text-xs md:text-sm">{moment(item.date).format("LLL")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Empty State */}
      {(!data || data.length === 0) && (
        <div className="text-center py-8">
          <div className="text-white-200 text-lg">Henüz kiti yükleme verisi bulunmuyor.</div>
        </div>
      )}
    </div>
  );
};

export default KitiRecharge;